// @ts-nocheck

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CategoriesState } from '@/types/categories';
import { CategoryFullSchema } from '@/types/categories';
import { getCategories, getCategory, updateCategory } from './thunks';

const initialState: CategoriesState = {
  categories: [],
  currentCategory: null,
  isLoading: false,
  error: null,
};

export const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    setCurrentCategory: (state, action: PayloadAction<CategoryFullSchema | null>) => {
      state.currentCategory = action.payload;
    },
    clearError: state => {
      state.error = null;
    },
    resetCurrentCategory: state => {
      state.currentCategory = null;
    },
    resetCategories: state => {
      state.categories = [];
    },
  },
  extraReducers: builder => {
    builder
      // Get Categories
      .addCase(getCategories.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.categories = action.payload;
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      // Get Category
      .addCase(getCategory.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.currentCategory = action.payload;
      })
      .addCase(getCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      // Update Category
      .addCase(updateCategory.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        // Update the current category if it's the one being updated
        if (state.currentCategory?.id === action.payload.id) {
          state.currentCategory = action.payload;
        }
        // Update the category in the list if it exists
        const categoryIndex = state.categories.findIndex(
          category => category.id === action.payload.id
        );
        if (categoryIndex !== -1) {
          // Convert CategoryFullSchema to CategorySchema for the list
          const { number_of_children, children, ...categoryForList } = action.payload;
          state.categories[categoryIndex] = categoryForList;
        }
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setCurrentCategory, clearError, resetCurrentCategory, resetCategories } =
  categoriesSlice.actions;

export const categoriesReducer = categoriesSlice.reducer;
